
import {
  schema, normalize
} from 'normalizr'

import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'

import { adaptTaxonomySkillsToStore } from '@/utils/skills'
import {
  CUSTOM_CONTENT_AUDIENCE_TYPES,
  CUSTOM_CONTENT_FIELDS,
} from '@/constants/customContent'

// Define answer schema
const videosSchema = new schema.Entity('videos')
const videosListSchema = [videosSchema]

export function adaptVideosToStore({ data }) {
  const entries = normalize(data.results, videosListSchema)
  return {
    entries: entries.entities.videos,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptVideoToApi(video = {}) {
  let payload = {
    name: video.name,
    s3_video_url: video.source,
    duration_in_seconds: video.duration_in_seconds,
    jwplayer_id: video.jwplayer_id,
    slug: video.slug,
    metadata: {
      company: video.company.toLowerCase()
    },
    files: video.files,
    type: video.type,
  }

  if (
    Object.prototype.hasOwnProperty.call(
      video,
      CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE
    )
  ) {
    payload[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE] =
      video[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE] ||
      CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC
  }

  payload = omitBy(payload, isNil)
  //Can send null value
  payload.instructor_id = video.instructor_id
  return payload
}

export function adaptVideoToStore({ data }) {
  const video = {
    id: data.id,
    name: data.name,
    source: data.s3_video_url,
    duration_in_seconds: data.duration_in_seconds,
    jwplayer_id: data.jwplayer_id,
    slug: data.slug,
    created: data.created,
    modified: data.modified,
    status: data.status,
    metadata: data.metadata,
    instructor_id: data.instructor_id,
    files: data.files,
    type: data.type,
    [CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE]:
      data[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE] ||
      CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC,
  }

  if (Array.isArray(data.taxonomy_skills)) {
    video.taxonomy_skills = adaptTaxonomySkillsToStore(data.taxonomy_skills)
  }

  return video
}
